"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const gatsby_1 = require("gatsby");
const React = require('react');
const layout_1 = require("../components/layout");
require("./index.css");
const Fragment = ({ html, cls }) => React.createElement("div", { className: cls, dangerouslySetInnerHTML: { __html: html } });
const IndexPage = ({ data: { tags, frags } }) => {
    const fragments = frags.edges.reduce((obj, { node }) => ({ ...obj, [node.fields.tag]: node.html }), {});
    return (React.createElement(layout_1.default, { front: true },
        React.createElement("h1", null, "Jason Phillips, PhD"),
        React.createElement("blockquote", null,
            React.createElement(Fragment, { html: fragments.intro })),
        React.createElement("h2", null, "Highlighted Technologies"),
        React.createElement(Fragment, { cls: "technologiesSummary", html: fragments.technologies }),
        React.createElement("h2", { className: "frontDivision close" }, "Employment"),
        React.createElement("h3", null, "Engineering Manager (previously Principle, Senior) Software Engineer"),
        React.createElement("div", { className: "c" },
            React.createElement("i", null, "2020 - Present"),
            ", Slite Inc"),
        React.createElement(Fragment, { html: fragments.slite }),
        React.createElement("h3", null, "Lead Developer"),
        React.createElement("div", { className: "c" },
            React.createElement("i", null, "2018 - 2020"),
            ", Overlay.ai"),
        React.createElement(Fragment, { html: fragments.overlay }),
        React.createElement("h3", null, "Senior Web & Integrations Analyst"),
        React.createElement("div", { className: "c" },
            React.createElement("i", null, "2008 - 2020"),
            ", The University of Alabama"),
        React.createElement(Fragment, { html: fragments.alabama }),
        React.createElement("h3", null, "Developer"),
        React.createElement("div", { className: "c" },
            React.createElement("i", null, "2016 - 2018 (freelance / consulting)"),
            ", Brewery Buddy, LLC"),
        React.createElement(Fragment, { html: fragments.brewery }),
        React.createElement("h2", { className: "frontDivision" }, "Education"),
        React.createElement(Fragment, { html: fragments.education }),
        React.createElement("h2", { className: "frontDivision" }, "Additional Information & References"),
        React.createElement(Fragment, { html: fragments.closing })));
};
exports.pageQuery = gatsby_1.graphql `
query tag {
  tags: allMarkdownRemark(
    filter: { fields: { kind: { eq: "content" }, subPath: { eq: "technologies" } } }
  ) {
    totalCount
    edges {
      node {
        fields {
          slug
          subPath
        }
        frontmatter {
          tags
          title
          parent
        }
      }
    }
  }
  frags: allMarkdownRemark(filter: {fields: {kind: {eq: "fragment"}}}) {
    edges {
      node {
        html
        fields {
          tag
        }
      }
    }
  }
}
`;
exports.default = IndexPage;
